import { render, staticRenderFns } from "./EditableMultiselect.vue?vue&type=template&id=52e3cd16&scoped=true"
import script from "./EditableMultiselect.vue?vue&type=script&lang=js"
export * from "./EditableMultiselect.vue?vue&type=script&lang=js"
import style0 from "./EditableMultiselect.vue?vue&type=style&index=0&id=52e3cd16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e3cd16",
  null
  
)

export default component.exports